import {
  tableV2MinimumTableWidth,
  tableV2PanelSx,
} from '@/features/shared/components/tableSystem/TableV2Primitives';
import type { SxProps, Theme } from '@/ui/primitives';

export const entityDailyHistorySurfaceBackground = 'var(--surface-card)';
export const entityDailyHistoryMinimumTableWidth = tableV2MinimumTableWidth;

export const entityDailyHistorySurfaceSx = {
  backgroundColor: entityDailyHistorySurfaceBackground,
} satisfies SxProps<Theme>;

export const entityDailyHistoryScrollContainerSx = [
  tableV2PanelSx,
  entityDailyHistorySurfaceSx,
] satisfies SxProps<Theme>;

export const entityDailyHistoryTableSx = {
  minWidth: entityDailyHistoryMinimumTableWidth,
} satisfies SxProps<Theme>;
